import React from "react";

import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import TelegramIcon from "@material-ui/icons/Telegram";
import StorefrontIcon from "@material-ui/icons/Storefront";
import PublicIcon from "@material-ui/icons/Public";
import ForumIcon from "@material-ui/icons/Forum";

const ConnectionIcon = ({ connectionType, style }) => {
  const iconStyle = {
    ...style,
    marginLeft: 0,
    marginRight: 0,
  };

  return (
    <React.Fragment>
      {[
        "whatsapp",
        "cloudapi",
        "waba",
        "haba",
        "hub360",
        "evolution",
        "waha",
        "wuzapi"
      ].includes(String(connectionType || "").toLowerCase()) && (
        <WhatsAppIcon style={{ ...iconStyle, color: "#25D366" }} />
      )}
      {connectionType === "instagram" && (
        <InstagramIcon style={{ ...iconStyle, color: "#e1306c" }} />
      )}
      {connectionType === "facebook" && (
        <FacebookIcon style={{ ...iconStyle, color: "#3b5998" }} />
      )}
      {connectionType === "telegram" && (
        <TelegramIcon style={{ ...iconStyle, color: "#0088cc" }} />
      )}
      {connectionType === "mercadolivre" && (
        <StorefrontIcon style={{ ...iconStyle, color: "#FFE600" }} />
      )}
      {connectionType === "stays" && (
        <PublicIcon style={{ ...iconStyle, color: "#0f766e" }} />
      )}
      {connectionType === "internal" && (
        <ForumIcon style={{ ...iconStyle, color: "#455A64" }} />
      )}
    </React.Fragment>
  );
};

export default ConnectionIcon;
